// extracted by mini-css-extract-plugin
export default {"form":"b4ce5511ceaa","productList":"e20ee542c874","email":"a894f95a87f6","warning":"bed77929ac75"};